import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, CircularProgress } from '@mui/material';
import ArticleCard from '../Blog/ArticleCard';
import BlogService from '../../services/blog-service';
import { BlogArticle } from '../../types/blog';

const FeaturedArticles: React.FC = () => {
  const [articles, setArticles] = useState<BlogArticle[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await BlogService.getFeaturedArticles();
        setArticles(data);
      } catch { /* graceful degradation */ }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={24} /></Box>;
  if (articles.length === 0) return null;

  return (
    <Box sx={{ py: 4 }}>
      <Typography variant="h4" component="h2" sx={{ fontWeight: 700, mb: 3 }}>From the Blog</Typography>
      <Grid container spacing={3}>
        {articles.map((article) => (
          <Grid item xs={12} sm={6} md={4} key={article.articleId}>
            <ArticleCard article={article} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturedArticles;
